import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M27.06,4.75H4.94a2.5,2.5,0,1,0,0,5h.27v15a2.45,2.45,0,0,0,2.41,2.49H24.38a2.45,2.45,0,0,0,2.41-2.49v-15h.27a2.5,2.5,0,1,0,0-5Zm-1.57,20A1.15,1.15,0,0,1,24.38,26H7.62a1.15,1.15,0,0,1-1.11-1.19v-15h19ZM27.06,8.44H4.94a1.2,1.2,0,1,1,0-2.39H27.06a1.2,1.2,0,1,1,0,2.39Z' }),
  React.createElement('rect', { x: '11.39', y: '15.2', width: '9.22', height: '1.3' })
));